import React, { Component } from 'react';

//styles
import './App.scss';

import Footer from '../Footer/Footer';
import Header from '../Header/Header';
import TopSection from '../TopSection/TopSection';
import GallerySection from '../GallerySection/GallerySection';
import '../../static/fonts/opensanshebrew/stylesheet.css'
import { isMobile, isIos } from '../../static/helper'
import { GA_Event, VirtualPageview, Prof, Uri } from '../Analytics/Analytics'
import ModalVideo from 'react-modal-video';
import PharseSection from '../PhraseSection/PharseSection';
import VideosSection from '../VideosSection/VideosSection.jsx';
import { scrollDown } from '../../static/scrollAnimation';



class App extends Component {
  constructor() {
    super();
    this.spoiIM = document.createElement("script");
    this.spoiIM.src = "https://launcher.spot.im/spot/sp_8cK4iLHH";
    this.spoiIM.setAttribute("data-spotim-module", "spotim-launcher");
    this.spoiIM.setAttribute("data-post-url", "https://z.ynet.co.il/mshort/content/eurovision2019");
    this.spoiIM.setAttribute("data-post-id", "http://localhost:3000/#/");
    this.state = {
      videoId: "",
      isOpen: false
    }
  }
  openModal = (videoId) => {
    GA_Event("Video_Play", videoId);
    this.setState({ isOpen: true, videoId })
  }
  adsPush() {
    var _adsManager = new window.AdsManager();
    if (isMobile()) {
      _adsManager.defineSlots([_adsManager.transitionSlot]);
    }
    if (isMobile()) {
      window.googletag.cmd.push(() => { window.googletag.display("gpt-transition"); });
    }
  }

  componentDidMount() {
    // document.querySelector("#spotIm").appendChild(this.spoiIM)
    VirtualPageview(Uri + Prof, "eurovision2019");
    this.adsPush();
    window.history.scrollRestoration = "auto";

    if (isMobile() || isIos()) {
      window.googletag.cmd.push(function () { window.googletag.display('div-gpt-ad-1549550549588-0'); });
      window.googletag.cmd.push(function () { window.googletag.display('div-gpt-ad-1549550444249-0'); });

    }
    else {
      window.googletag.cmd.push(function () { window.googletag.display('div-gpt-ad-1549550730694-0'); });
      window.googletag.cmd.push(function () { window.googletag.display('div-gpt-ad-1549550675493-0'); });
      window.googletag.cmd.push(function () { window.googletag.display('div-gpt-ad-1549550586989-0'); });
    }
    // window.location.hash = window.decodeURIComponent(window.location.hash);
    const handleHashChange = () => {
      const hashParts = window.location.hash.split('#');
      if (hashParts.length > 1) {
        const hash = hashParts.slice(-1)[0];
        // document.querySelector(`.${hash}`).scrollIntoView();
        scrollDown(`${hash}`, 0, 150);

        var scrolledY = window.scrollY;

        if (scrolledY) {
          window.scroll(0, scrolledY - 0);
        }
      }
      else {
        var scrollPos = parseInt(localStorage.getItem('scrollPos'));
        if (!(window.location.hash.indexOf("article") > -1)) {
          if (scrollPos > 0) {
            window.scrollTo(0, scrollPos);
            localStorage.setItem('scrollPos', 0);
          }
        }
      }
    };
    setTimeout(() => handleHashChange(), 700);
    // window.onhashchange = handleHashChange;

  }

  render() {
    return (
      <div className="App" id="App">
        {/* <Router basename="/"> */}
        <div>
          {/* <Route exact path="/" render={() => */}
          <div>
            <Header isArticle={false} sendGA={GA_Event} />
            <ModalVideo channel='youtube' isOpen={this.state.isOpen} videoId={this.state.videoId} onClose={() => this.setState({ isOpen: false })} />
            <TopSection />
            {
              isMobile() || isIos() ?
                <div id='div-gpt-ad-1549550549588-0' className="bunners mobile"></div>
                :
                <div id='div-gpt-ad-1549550730694-0' className="bunners"></div>
            }
            <VideosSection isYouTubeModalOpen={this.state.isOpen} openYouTubeModal={this.openModal} />
            {
              !isMobile() && !isIos() ?
                <div id='div-gpt-ad-1549550675493-0' className="bunners"></div>
                : ""}
            <PharseSection />
            <GallerySection isYouTubeModalOpen={this.state.isOpen} openYouTubeModal={this.openModal} />
              {/*<div className="bottom-section">
             <div id="spotIm" className="spotIm"></div>
              {
                isMobile() || isIos() ?
                  <div id='div-gpt-ad-1549550444249-0' className="bunners mobile"></div>
                  :
                  <div id='div-gpt-ad-1549550586989-0' className="bunners" style={{ "paddingLeft": "30px", "boxSizing": "border-box" }}></div>
              }
            </div> */}
            <Footer isArticle={false} />
          </div>
          {/* } /> */}
          {/* <Route path="/article/:article/:comment?" component={(router) => <div><Article router={router} renderPlaybazz={this.renderPlaybazz} /><Footer isArticle={true} /></div>} /> */}
        </div>
        {/* </Router> */}
        {/* <div id="gpt-transition"></div> */}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/Components/App/App.js